import * as React from 'react';
import { Container, Header, Segment } from 'semantic-ui-react';
import { ItemsQuery } from '~/Api';
import { SubscriptionsRequest } from '~/Api/Subscriptions';
import { useApiResults } from '~/ApiHooks';
import { useRequireAccessToken } from '~/Application/useRequireAccessToken';
import * as Impersonate from '~/Impersonate';
import { TagBlacklist } from '~/InfoCard';
import { Subscriptions } from '~/Subscriptions';
var ItemsPerPage = 50;
export var UserProfile = function () {
    var _a = useRequireAccessToken(), token = _a[1];
    var _b = useApiResults(function (lastResponse) {
        var _a;
        return lastResponse === null || lastResponse.pagination.currentPage < lastResponse.pagination.totalPages
            ? new SubscriptionsRequest(new ItemsQuery(((_a = lastResponse === null || lastResponse === void 0 ? void 0 : lastResponse.pagination.currentPage) !== null && _a !== void 0 ? _a : 0) + 1, ItemsPerPage, []))
            : null;
    }, [token]), results = _b[0], loadNext = _b[1], reload = _b[2];
    var currentPage = results.value !== null ? results.value.length : 1;
    return (<Container>
			<Impersonate.Panel />
			<Segment padded='very'>
				<Header>Skryté aktuality</Header>
				<TagBlacklist />
			</Segment>
			<Segment padded='very'>
				<Header>Notifikace Info Karet</Header>
				<Subscriptions subscriptions={results} onLoad={loadNext} onReload={function () {
            reload(currentPage);
        }}/>
			</Segment>
		</Container>);
};
